import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import {Router} from '@angular/router';

@Injectable()
export class ExceptionService {

 constructor(private router: Router) { }

    handleError: (errorResponse: any) => Observable<any> = (errorResponse: any) => {
        let errorMsg: string;
        let serverErrorMsg: string;
        if ( errorResponse instanceof Response ) {
            const errBody = errorResponse['_body'];
            const errJson: any =  errorResponse.json() || '';
            if (errorResponse.status === 401) {
                console.error(`ExceptionService.handleError() => ${errorResponse}`);
                // If Secured Message doesn't contain password
                if (errJson.status === '401' && errJson.message) {
                    return Observable.throw(errJson);

                // If Token is Invalid or not passed in Header
                }else {
                    this.router.navigate(['/401']);
                    return Observable.of(null);
                }
            }

            // const error: string = errJson.error || JSON.stringify(errJson);
            serverErrorMsg = `${errorResponse.status} - ${errorResponse.statusText || ''} ${errBody}`;
            errorMsg = `Due to circumstances beyond our control, We are not able to process your request.  
                        Please try again later or call your Claim Representative directly.  
                        We apologize for the inconvenience. TrackingId: ${errJson.trackingId}`;
        }else {
            errorMsg = errorResponse.stack ? errorResponse.stack : errorResponse;
            serverErrorMsg = errorMsg;
        }
        console.error(`ExceptionService.handleError() => ${serverErrorMsg}`);

       return Observable.throw(errorMsg);
    }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/app/common/service/exception.service.ts